import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { Switch, Route, NavLink } from 'react-router-dom';

import CrmDuplicatesContainer from './CrmDuplicatesContainer/CrmDuplicatesContainer';
import CrmCrossChecksContainer from './CrmCrossChecksContainer/CrmCrossChecksContainer';
import CrossCheckTestNewContainer from './CrossCheckTestNewContainer';
import CrossCheckTestEditContainer from './CrossCheckTestEditContainer';
import DuplicateTestNewContainer from './DuplicateTestNewContainer';
import DuplicateTestEditContainer from './DuplicateTestEditContainer';

const QaLayout = () => {
  return (
    <div className="QaLayout">
      <div className="QaLayout__header">
        <h3 className="section-title">Quality Assurance</h3>

        <ul className="nav nav-tabs card-nav-tabs">
          <li className="nav-item">
            <NavLink
              className="nav-link"
              to="/qa/crm/duplicates"
              isActive={(match, { pathname }) => pathname.match('/qa/crm')}
          >
            CRM
            </NavLink>
          </li>
        </ul>
      </div>

      <Card className="QaLayout__body minimal">
        <CardBody>
          <Switch>
            <Route exact path="/qa/crm/cross-check-tests" component={CrmCrossChecksContainer} />
            <Route exact path="/qa/crm/cross-check-tests/new" component={CrossCheckTestNewContainer} />
            <Route exact path="/qa/crm/cross-check-tests/:id/edit" component={CrossCheckTestEditContainer} />

            <Route exact path="/qa/crm/duplicates" component={CrmDuplicatesContainer} />
            <Route exact path="/qa/crm/duplicates/new" render={(props) => <DuplicateTestNewContainer deviceType="crm" {...props} />} />
            <Route exact path="/qa/crm/duplicates/:id/edit" component={DuplicateTestEditContainer} />
          </Switch>
        </CardBody>
      </Card>
    </div>
  );
}

export default QaLayout;



// WEBPACK FOOTER //
// ./src/features/qa/QaLayout.js